import { IAbsence, IUserGroup, IUserShort } from '@valhalla/data/entities';

export interface IUserShortInfo {
	userIds: number[];
}
export interface IRecipient {
	type?: IRecipientType;
	name: string;
	id: number;
}

export enum IRecipientType {
	unknown = 'Unknown',
	user = 'User',
	group = 'Group',
}

export interface IRecipientResponse {
	total: 0;
	recipients: IRecipient[];
}

export interface IRecipientResolve {
	target?: 'ExtParam' | 'Performers' | 'Subscribers';
	search?: string;
	limit?: number;
	offset?: number;
	subcatId: number;
	taskId: number;
	extParamId?: number;
	recipientTypes?: string[];
	selectedRecipients?: {
		users?: number[];
		groups?: number[];
		orgUnits?: number[];
		mailBoxes?: number[];
	};
}

export interface IGetUserSessionInfoResult {
	userId: number;
	isAdmin: boolean;
	groups: IUserGroup[];
}

export interface IGetUserStatusCriteria {
	userIds: number[];
}

export interface IGetUserSettingsResult {
	id: number;
	startPage: string;
	enableDesktopNotifications: boolean;
	showUserTooltip: boolean;
	fileOnClickActionMode: MsOfficeClickActions;
	navigationPanelLogo?: string;
	calendarVisible?: string;
	categoryVisible?: string;
	chooseLanguageVisible?: string;
	createButtonVisible?: string;
	ownTaskSubcatId?: number;
	openConversationOnCommentClick?: boolean;
	favoriteVisible?: string;
	lentaVisible?: string;
	mailVisible?: string;
	personalVisible?: string;
	reportVisible?: string;
	searchVisible?: string;
	staffVisible?: string;
	orgChartVisible?: string;
	personalMenuTimeSheet: string;
	personalMenuKanban: string;
	personalMenuOthers: string;
	userProfileActivity: string;
	userProfileAgenda: string;
	userProfileCalendar: string;
	userProfileCustomer: string;
	userProfileJournal: string;
	showCreatePersonalTaskButton?: string;
	userProfileReport: string;
	userProfileLaborCost: string;
	userProfilePerformer: string;
	/** настройка показа мтф */
	mtfPreview?: string;
	useNewTaskCard?: boolean;
	commentsViewMode?: 'down' | 'right';
	accessToOtherUserProfiles?: boolean;
	jitsiServicePersonalRoomVisible: string;
	jitsiServicePersonalRoom: string;
	notAutoSetCommentAsQuestion?: boolean;
	sendCommentByEnter?: boolean;
	autoReadCommentsInTask?: boolean;
	userUISettings: {
		allowChatsDesktopNotification: boolean;
		allowOverdueTasksDesktopNotification: boolean;
		allowQuestionsDesktopNotification: boolean;
		allowSignaturesDesktopNotification: boolean;
		allowUnreadCommentsDesktopNotification: boolean;
		apenCharts: boolean;
		colorTheme: string;
		contextModalWindows: boolean;
		filterCommentsDependByLentaSettings: boolean;
		fontSize: string;
		navigationPanelColor: boolean;
		navigationPanelPosition: string;
		panelsFontSize: string;
		popupChats: boolean;
		showCalendarInNavigationPanel: boolean;
		showIAndMeInsteadOfDisplayName: boolean;
		showStartupPageOnLogoClick: boolean;
		showUserCardOnMouseOver: boolean;
		translateCommentsInFeed: boolean;
		useNewTaskCard: boolean;
		useStartUpPage: boolean;
		userNameMode: string;
		userStartPageType: string;
		viewCommentsInTaskState: string;
		viewTaskState: string;
		showNavigationAlways: boolean;
	};
}

export interface IGetUserContactsCriteria {
	userName: string;
}

export enum MsOfficeClickActions {
	download = 'Download',

	webapps = 'PreviewInWebApps',

	webdav = 'EditInWebDav',

	default = 'Default',
}

export interface ICowokersCriteria {
	limit: number;
	offset: number;
	search?: string;
	FiltersData?: string;
}

export interface ICowokersFilter {
	column: string;
	type: CoworkersSearchTypes;
	value: string;
}

export enum CoworkersSearchTypes {
	includes = 'includes',
	excludes = 'excludes',
	equal = 'equal',
	unequal = 'unequal',
	startWith = 'startWith',
	endWith = 'endWith',
}

export enum MtfAreaView {
	right = 'right',
	bottom = 'bottom',
	inPlace = 'newWindow',
	popup = 'popupWindow',
}

export enum VisibleValue {
	noSet = 'NoSet',
	visible = 'Visible',
	invisible = 'Invisible',
}

export interface IUserSignatures {
	taskUserSignatures: ITaskUserSignatures[];
	activeTaskIds: number[];
}

export interface ITaskUserSignatures {
	taskId: number;
	taskText: string;
	taskSignatureId: number;
	isQueued: boolean;
	isAsyncAvailable: boolean;
	pcIsServerSign: boolean;
	canEditAcceptors: boolean;
	timeToSignCanBeChanged: boolean;
	subcat: {
		parentCategoryId: number;
		defaultViewType: any;
		isPortal: boolean;
		name: string;
		id: number;
	};
	guid: string;
	description: string;
	requestor: Partial<IUserShort>;
	extParams: any[];
	owner: Partial<IUserShort>;
	responsiblePerformer: Partial<IUserShort>;
	signatureResolutions: ITaskUserSignatureResolutions[];
	edsType: any;
	taskSignatureOrderedTime: string;
	taskSignatureInitializeDate: string;
	signatureAcceptants: ISignatureAcceptants[];
	signatureRouteSigners: any;
	acceptorAssistants: any[];
	edsFiles: any[];
	requestReasonOnAccept: boolean;
	canBeEscalated: boolean;
	mobileTemplate: string;
	reason: string;
	isEds: boolean;
}

export interface ITaskUserSignatureResolutions {
	resolutionTypeId: number;
	name: string;
	signatureAction: ISignatureActionType;
	reasonRequired: boolean;
	needConfirm: boolean;
	dialogHeader: any;
}

export enum ISignatureActionType {
	accept = 'Accept',
	reject = 'Reject',
	delete = 'Delete',
	delegate = 'Delegate',
	journal = 'openJournal',
	escalate = 'Escalate',
}

export interface ISignatureAcceptants {
	isOnline: boolean;
	isLastOnlineFromMobileApp: boolean;
	lastOnlineTime: string;
	lastPersonalInfoUpdateTime: string;
	absences: IAbsence[];
	userState: {
		isOnline: boolean;
		absence: any;
		absenceTypeUserColor: any;
		isFired: boolean;
		isInMaternityLeave: boolean;
		isEmployee: boolean;
	};
	name: string;
	id: number;
}
